export const CREATE_POST_COMPLETED = "project/post/createPostCompleted";
export const GET_POSTS_COMPLETED = "project/post/getPostsCompleted";
export const FIND_CATEGORIES_COMPLETED = "project/post/findCategoriesCompleted";
export const GET_USER_POSTS_COMPLETED = "project/post/getUserPostsCompleted";
export const DELETE_POST_COMPLETED = "project/post/deletePostCompleted";
export const ADD_IMAGE_COMPLETED = "project/post/addImageCompleted";
export const FIND_POST_BY_ID_COMPLETED = "project/post/findPostByIdCompleted";
export const CLEAR_POST = "project/post/clearPost";
export const MODIFY_POST_COMPLETED = "project/post/modifyPostCompleted";
export const FILTER_POST_COMPLETED = "project/post/filterPostCompleted";

export const GET_NEW_POSTS_COMPLETED= "project/post/getNewPostsCompleted";


export const DELETE_COMMENT_COMPLETED = "project/post/deleteCommentCompleted";
export const CREATE_COMMENT_COMPLETED = "project/post/createCommentCompleted";
export const GET_COMMENTS_COMPLETED = "project/post/getCommentsCompleted";
export const CREATE_ANSWER_COMPLETED = "project/post/createAnswerCompleted";
export const GET_USER_POST_COMPLETED = "project/post/getUserPostCompleted";
export const GET_POST_SECTIONS_COMPLETED = "project/post/getPostSectionsCompleted";
export const ADD_POST_SECTIONS_COMPLETED = "project/post/addPostSectionsCompleted";
export const DELETE_POST_SECTIONS_COMPLETED = "project/post/deletePostSectionsCompleted";
